import React, { useEffect, useMemo, useState } from 'react';
import { useConsolidationDefaultCategory } from './api/getConsolidationDefaultCategory';
import { Box } from '@mui/material';
import LoadingChart from '@/features/dashboard/components/LoadingChart';
import BarChartInadimplenceCategoria from '@/components/Base/BarChartInadimplenceCategoria';
import { EmptyComponent } from './components/EmptyComponent';
import PeriodFilterDash from '@/components/Base/PeriodFilterDash';
import { generateLastYears } from './CashFlowTela';

const ScoreInadimplenciaCategoriaMenu = ({ year, month, days }) => {
  const [selectedYear, setSelectedYear] = useState(year || new Date().getFullYear());
  const [selectedMonth, setSelectedMonth] = useState(month || new Date().getMonth() + 1);
  const [selectedStartDate, setSelectedStartDate] = useState(null);
  const [selectedEndDate, setSelectedEndDate] = useState(null);
  const [listYears, setListYears] = useState(generateLastYears(5));

  const { data: defaultData, isFetching } = useConsolidationDefaultCategory({
    year: selectedYear || null,
  });


  const currentMonthFormatted = new Date().toLocaleString('pt-BR', { month: 'short' });
  const capitalizedMonth = currentMonthFormatted.charAt(0).toUpperCase() + currentMonthFormatted.slice(1).toLowerCase();

  const selectedData = defaultData?.find((item) => {
    return item.ano === selectedYear
  });

  const currentMonthData = useMemo(() => {
    if (!selectedData?.month_category) return null;

    const monthNames = ["Jan", "Fev", "Mar", "Abr", "Mai", "Jun", "Jul", "Ago", "Set", "Out", "Nov", "Dez"];

    const selectedMonthName = selectedMonth ? monthNames[selectedMonth - 1] : null;

    console.log(selectedMonthName);
    if (selectedMonthName) {
      return selectedData.month_category.find((item) => item.mes === selectedMonthName);
    }

    return selectedData.month_category.find((item) => capitalizedMonth === item.mes);
  }, [selectedData, selectedMonth, capitalizedMonth]);

  return (
    <>
      <LoadingChart loading={isFetching} />

      <Box marginTop={'10px'} width={'100%'}>
        <PeriodFilterDash
          startDate={selectedStartDate}
          endDate={selectedEndDate}
          onStartDateChange={setSelectedStartDate}
          onEndDateChange={setSelectedEndDate}
          refetchDashboard={() => {}}
          listYears={listYears}
          setSelectedYear={setSelectedYear}
          setSelectedMonth={setSelectedMonth}
          selectedYear={selectedYear}
          selectedMonth={selectedMonth}
          showPeriodFilter={false}
        />
      </Box>

      {defaultData?.length && !isFetching ? (
        <BarChartInadimplenceCategoria categories={currentMonthData?.categories || []} />
      ) : (
        <EmptyComponent />
      )}
    </>
  );
};

export default ScoreInadimplenciaCategoriaMenu;
